module.exports = __webpack_public_path__ + "img/mp-t.8e478ca5.png";